import { css } from 'emotion'

export const cssContainerOuter = css`
    position: relative;
    display: block;
    margin-left: auto;
    margin-right: auto;
`

export const cssContainerInner = css`
    position: relative;
    display: block;
    top: 0;
    left: 0;
`

export const cssAsset = css`
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    vertical-align: middle;
    top: 0;
    left: 0;
`
